// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__H5057","primary":"button_primary__3C1qu","secondary":"button_secondary__1yQBY","tertiary":"button_tertiary__1e-wZ","danger":"button_danger__2liOG"};